import React, { useCallback, useEffect, useMemo } from 'react';
import { PageLayout } from './PageLayout';
import { useMeetingsStoreContext, useUserStoreContext } from '@store';
import { authService } from '@services';
import { RedirectToSSOPage } from '@pages';
import { MeetingListSearchQuery } from '@api';
import { AppPageHeader } from '@components';
import { useHistory } from "react-router-dom";
import { routes } from '@routes';

export interface AppPageLayoutProps {
    content: JSX.Element,
}

function AppPageLayout(props: AppPageLayoutProps): JSX.Element {
    const { dispatch: userStoreDispatch, state: UserStoreState,  } = useUserStoreContext();
    const { content } = props;
    const history = useHistory();
    const { dispatch: meetingStoreDispatch, state: MeetingsStoreState } = useMeetingsStoreContext();

	const onChangeSearchQuery = useCallback((newQuery: MeetingListSearchQuery): void => {
		meetingStoreDispatch({
			type: 'SET_SEARCH_QUERY',
			payload: newQuery,
		});

        if (history.location.pathname != routes.index.path) {
            history.push(routes.index.path);
        }
	}, [history, meetingStoreDispatch]);
	
	const headerView = useMemo(() => {
		return (
			<AppPageHeader
				defaultSearchValue={MeetingsStoreState.query}
				changeSearchQuery={onChangeSearchQuery}
			/>
		);
	}, [onChangeSearchQuery, MeetingsStoreState]);

    useEffect(() => {
        const fetchUserInfo = async () => {
            const user = await authService.getUser();

            if (user == null) {
                sessionStorage.setItem("pageBeforeLogin", history.location.pathname);
                authService.login();
            }
            else {
                if (UserStoreState.user == null) {
                    userStoreDispatch({
                        type: 'SET_USER',
                        payload: {
                            avatarSrc: null,
                            rights: user.profile.roles,
                            isLoggedIn: user != null,
                            user: user
                        },
                    });
                }
            }
        };

        fetchUserInfo();

	}, [userStoreDispatch, UserStoreState, history]);

    if (UserStoreState.isLoggedIn) {
        return <PageLayout header={headerView} content={content} />
    }
    else
    {
        return <RedirectToSSOPage />
    }
}

export { AppPageLayout };